<template>
  <div v-if="$apollo.loading">
    <spinner />
  </div>
  <div v-else class="registration-success-page-container">
    <div class="registration-success-page">
      <img src="/assets/successful-payment.png" alt="Uspješna kupovina" />
      <div style="display: flex; flex-direction: column; gap: 0.5rem">
        <span class="my-page-title">{{ $t('paymentSuccessful') }}</span>
        <span id="description">Za više informacija provjeri svoj e-mail.</span>
        <span id="description">Hvala na povjerenju.</span>
      </div>
      <a
        v-if="user && order"
        target="_blank"
        :href="`${customerURL}/orders/${order.uuid}`"
        style="margin-top: 24px"
      >
        <main-button color="#333" style="border-radius: 0">Pogledaj Narudžbu</main-button>
      </a>
    </div>
    <div v-if="adsLoaded && ads.length" class="shop-section">
      <h4>CoreEvent partner ponuda</h4>
      <div class="shop-cards-section">
        <a
          v-for="ad in ads.slice(0, 3)"
          :key="ad.url"
          class="shop-card"
          target="_blank"
          :href="ad.url"
        >
          <img v-if="ad.logoUrl" class="logo-img" :src="ad.logoUrl" />
          <img class="product-img" :src="ad.imageUrl" />
          <div class="shop-card-details">
            <h5>{{ ad.title }}</h5>
          </div>
        </a>
      </div>
    </div>
    <div v-else-if="adsLoaded">
      <img src="/assets/successful-payment.svg" />
    </div>
  </div>
</template>

<script>
import { getOrganizationStoreOrderInfoByUUID } from '@/http'
import { GET_LOGGED_USER } from '@/graphql/user.graphql'
import { customerURL, landingURL } from '@/utils'

export default {
  name: 'store-successful-payment',
  components: {},
  data() {
    return {
      ticketDownloaded: false,
      ticketError: false,
      customerURL,
      landingURL,
      user: null,
      order: null,
      ads: [],
      adsLoaded: false,
    }
  },
  async mounted() {
    const uuid = this.$router.history.current.params.orderUUID
    localStorage.removeItem('organizationStoreOrder')
    localStorage.removeItem('organizationSubscriptionStoreOrder')
    localStorage.removeItem('organizationMembershipStoreOrder')
    this.order = await getOrganizationStoreOrderInfoByUUID(uuid)

    const { data = {} } = await this.getUser()
    const { me: user } = data || {}
    this.user = user
  },
  methods: {
    async getUser() {
      return this.$apollo.query({
        query: GET_LOGGED_USER,
      })
    },
  },
}
</script>

<style scoped>
.my-page-title {
  font-family: Raleway, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 2.25rem;
  line-height: 2.8rem;
  color: #333;
}
.registration-success-page-container {
  margin: auto;
  max-width: 1440px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 6rem;
}

.registration-success-page {
  align-items: flex-start;
  max-width: 30rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

#description {
  font-family: Source Sans Pro, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 23px;
  color: #333333;
}

@media screen and (max-width: 1187px) {
  .registration-success-page-container {
    padding: 0 1rem;
    justify-content: center;
    flex-direction: column;
  }

  .registration-success-page {
    padding-bottom: 4rem;
  }

  .registration-success-page-container .shop-section {
    max-width: 38rem;
    width: calc(100% + 2.5rem);
    align-self: flex-end;
    margin-right: -2.5rem;
    border-radius: 1.5rem 0 0 1.5rem;
  }

  .shop-cards-section {
    overflow-x: scroll;
  }
}

.v-btn--disabled {
  border: none;
}

#download-ticket .v-progress-circular {
  margin-left: 10px;
}

.shop-section {
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  background: #cee4f2;
  border-radius: 1.5rem;
}

.shop-section h4 {
  font-family: 'Raleway';
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
  padding-bottom: 1.5rem;
}

.shop-cards-section {
  display: flex;
}

.shop-card:nth-of-type(1),
.shop-card:nth-of-type(2) {
  margin-right: 1.5rem;
}

.shop-card {
  display: flex;
  flex-direction: column;
  border-radius: 1rem;
  background: #f0f6fa;
  align-items: flex-start;
  max-width: 10.3rem;
}

.shop-card-details {
  padding: 16px 18px 24px;
}

.shop-card-details h5 {
  color: #0277bd;
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
}

.shop-card .logo-img {
  position: absolute;
  height: 2rem;
  width: auto;
  border-radius: 1rem 0;
}
.shop-card .product-img {
  border-radius: 1rem 1rem 0 0;
  height: 10.3rem;
  width: 10.3rem;
}
</style>
